import React from 'react';
import {
  DropdownButton,
  MenuItem,
  Panel,
  Col,
  FormControl,
  Form,
  FormGroup,
  ControlLabel
} from 'react-bootstrap';

import Modal from 'react-bootstrap/lib/Modal';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Button from 'react-bootstrap/lib/Button';
import Popover from 'react-bootstrap/lib/Popover';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import s from './POIModal.scss';

import withStyles from 'isomorphic-style-loader/lib/withStyles';

const mapItems = {
  'Kultura i rozrywka': [
    'Amfiteatr','Biblioteka','Dom kultury/świetlica','Filharmonia/opera','Kino','Klub muzyczny',
    'Klub gier i innych rozrywek','Muzeum','Teatr','Inny obiekt kultury i rozrywki',
  ],
  'Miejsca i obiekty kultu religijnego': [
    'Cerkiew','Cerkiew zabytkowa','Cmentarz','Cmentarz zabytkowy','Kapliczka','Kirkut','Kościół','Kościół zabytkowy',
    'Krzyż/figura','Synagoga','Synagoga zabytkowa','Inny obiekt kultu religijnego',
  ],
  'Miejsca sportu i wypoczynku': [
    'Basen','Dom zdrojowy','Fontanna','Leśniczówka/gajówka','Łowisko','Miejsce biwakowe','Obiekt sportowy/boisko',
    'Park','Plaża/kąpielisko','Stadion/hala sportowa','Stadnina koni','Wiata turystyczna','Wieża widokowa',
    'Wyciąg narciarski','Wypożyczalnia sprzętu rekreacyjnego','ZOO','Inny obiekt sportu i wypoczynku',
  ],
  'Placówki i obiekty użyteczności publicznej': [
    'Apteka','Bank','Bankomat','Gabinet lekarski','Galeria handlowa','Informacja turystyczna','Poczta',
    'Ośrodek zdrowia','Policja','Przechowalnia bagażu','Przedszkole/żłobek','Restauracja/kawiarnia/bar',
    'Salon piękności/fryzjer/kosmetyczka','Sąd','Sklep specjalistyczny','Sklep spożywczo-przemysłowy',
    'Siedziba urzędu','Straż pożarna','Szkoła',
    'Szpital','Targowisko','Toaleta publiczna',
    'Uczelnia wyższa','Usługi','Inny obiekt użyteczności publicznej',
  ],
  'Przyroda': [
    'Interesująca osobliwość przyrodnicza','Kamieniołom','Pomnik przyrody ożywionej',
    'Pomnik przyrody nieożywionej','Punkt widokowy',
    'Szczyt/punkt wysokościowy','Zbiornik wodny','Źródło','Źródło mineralne','Inny obiekt przyrodniczy',
  ],
  'Transport': [
    'Dworzec autobusowy','Dworzec/stacja kolejowa','Lotnisko','Lotnisko sportowe/lądowisko','Mechanik samochodowy',
    'Myjnia samochodowa','Parking','Parking rowerowy','Port/przystań','Postój taksówek','Przejście graniczne',
    'Przeprawa promowa','Przystanek autobusowy',
    'Przystanek kolejowy','Przystanek tramwajowy','Stacja paliw','Tama/jaz','Wypożyczalnia/stacja rowerów',
    'Wypożyczalnia samochodów','Inny obiekt związany z transportem',
  ],
  'Zabytki i obiekty historyczne': [
    'Budynek zabytkowy','Bunkier','Dworek/pałac','Fort/twierdza','Grodzisko/kurhan', 'Pole bitwy',
    'Pomnik/mogiła','Ruiny','Teren dawnej wsi','Zamek','Inny obiekt historyczny',
  ],
  'Inne': [
    'inne',
  ],
};

class POIModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      curCategory: 'Kultura i rozrywka',
      curTyp: 'Amfiteatr',
      check1: false,
      check2: false,
      check3: false,
      check4: false,
      check5: false,
      check6: false,
      check7: false,
      check8: false,
      check9: false,
      check10: false,
      formValues: {},
      check6Validation: true,
    };
  }
// id,
// kategoria,
// typ,
// nazwa_pelna,' +
// 'opis, +
//  opis_pelny,
//  kod_pocztowy, +
//  miejscowosc, +
//  ulica,+
//  nr_budynku,+
//  telefon,+
//  email,+
//  strona_www,+
//  czas_otwarcia,
//  wlasnosc,'
// nr_lokalu,
// dlugosc_geogr,
// szerokosc_geogr,
// symbol,
// x
// y

  resetKategoria = () => {
    this.setState({
      kategoria: null,
      typ: null,
    });
  }

  onChangeCategory = (e) => {
    this.setState({ curCategory: e.target.value, curTyp: mapItems[e.target.value][0] });
  }
  onChangeType = (e) => this.setState({ curTyp: e.target.value });

  onChangeFormControl = (e, controlName) => {
    this.setState({
      formValues: {
        ...this.state.formValues,
        [controlName]: e.target.value.length > 0 ? e.target.value : null,
      },
    });
  }

  onSelectAddItem = (e) => {
    if (e == 1) this.setState({ check1: true });
    else if (e == 2) this.setState({ check2: true });
    else if (e == 3) this.setState({ check3: true });
    else if (e == 4) this.setState({ check4: true });
    else if (e == 5) this.setState({ check5: true });
    else if (e == 6) this.setState({ check6: true });
    else if (e == 7) this.setState({ check7: true });
    else if (e == 8) this.setState({ check8: true });
    else if (e == 9) this.setState({ check9: true });
    else if (e == 10) this.setState({ check10: true });
    else console.info('error, wrong state');
  }

  prepareData = () => {
    // prepare data
    let currentState = this.state.formValues;
    currentState['kategoria'] = this.state.curCategory;
    currentState['typ'] = this.state.curTyp;
    return currentState;
  }

  render() {
    const popover = (
      <Popover id="modal-popover" title="popover">
        very popover. such engagement
      </Popover>
    );
    const tooltip = (
      <Tooltip id="modal-tooltip">
        wow.
      </Tooltip>
    );

    const dataNames = [
      'Kod pocztowy',
      'Miejscowość',
      'Ulica',
      'Nr budynku',
      'Nr lokalu',
      'Telefon',
      'Adres email',
      'Strona www',
      'Godziny otwarcia',
      'Własność',
    ];
    const dataItemsMapped = dataNames.map(
      (item, index) => <MenuItem value={index} eventKey={index + 1} key={index}>{item}</MenuItem>
    );

    return (
      <Modal show={this.props.showModal} onHide={this.props.onClose}>
        <Modal.Body>
          <div className="row">
            <div className="col-xs" />
            <div className="col-xs-12">
              <div className={"form-wrap"}>
                <h1>Utwórz nowy POI</h1>
                <Panel header={<h3>Rodzaj obiektu</h3>}>
                  <Form horizontal>

                    <FormGroup controlId="formHorizontalkategoria">
                      <Col componentClass={ControlLabel} sm={4}>
                        Kategoria:
                      </Col>
                      <Col sm={8}>
                        <FormControl
                          ref={(control) => { this.catControl = control; }}
                          onChange={(e)=>this.onChangeCategory(e)}
                          value={this.state.curCategory}
                          componentClass="select">
                          {/*{katItemsMapped}*/}
                          {Object.keys(mapItems).map((value, index) => {
                            return <option value={value} key={index}>{value}</option>
                          })}
                        </FormControl>
                      </Col>
                    </FormGroup>

                    <FormGroup controlId="formHorizontalTyp">
                      <Col componentClass={ControlLabel} sm={4}>
                        Typ:
                      </Col>
                      <Col sm={8}>
                        <FormControl value={this.state.curTyp} onChange={(e)=>this.onChangeType(e)} componentClass="select" >
                          {mapItems[this.state.curCategory].map((value, index) => <option value={value} key={index}>{value}</option>)}
                        </FormControl>
                      </Col>
                    </FormGroup>

                  </Form>
                </Panel>
                <Panel header={<h3>Dane obiektu</h3>} className="panel panel-warning">
                  <Form horizontal>

                    <FormGroup controlId="formHorizontalkategoria">
                      <Col componentClass={ControlLabel} sm={4}>
                        Nazwa pełna:
                      </Col>
                      <Col sm={8}>
                        <FormControl className="text" placeholder="..." onChange={(e) => this.onChangeFormControl(e, 'nazwa_pelna')} />
                      </Col>
                    </FormGroup>

                    <FormGroup controlId="formHorizontalTyp">
                      <Col componentClass={ControlLabel} sm={4}>
                        Opis:
                      </Col>
                      <Col sm={8}>
                        <FormControl componentClass="input" placeholder="..." onChange={(e) => this.onChangeFormControl(e, 'opis')} />
                      </Col>
                    </FormGroup>

                    <FormGroup controlId="formHorizontalTyp">
                      <Col componentClass={ControlLabel} sm={4}>
                        Pełny opis:
                      </Col>
                      <Col sm={8}>
                        <FormControl componentClass="textarea" placeholder="..." onChange={(e) => this.onChangeFormControl(e, 'opis_pelny')} />
                      </Col>
                    </FormGroup>

                    <FormGroup controlId="formHorizontalTyp">
                      <Col componentClass={ControlLabel} sm={4}>
                        Adres URL zdjęcia:
                      </Col>
                      <Col sm={8}>
                        <FormControl componentClass="input" placeholder="http://mojezdjecia.pl/zdjecie.jpg" onChange={(e) => this.onChangeFormControl(e, 'opis')} />
                      </Col>
                    </FormGroup>

                    <FormGroup controlId="formHorizontalTyp">
                      <Col componentClass={ControlLabel} sm={4}>
                        Adres URL wideo:
                      </Col>
                      <Col sm={8}>
                        <FormControl componentClass="input" placeholder="http://youtube.pl/mojewideo=sldfkjsdlfkj" onChange={(e) => this.onChangeFormControl(e, 'opis')} />
                      </Col>
                    </FormGroup>

                    {this.state.check1 ? <FormGroup controlId="formHorizontalKod">
                      <Col componentClass={ControlLabel} sm={4}>
                        Kod pocztowy:
                      </Col>
                      <Col sm={6}>
                        <FormControl className="input" placeholder="..-..." onChange={(e) => this.onChangeFormControl(e, 'kod_pocztowy')} />
                      </Col>
                      <Col sm={2}>
                        <Button onClick={()=>this.setState({check1: false})}><span className="buttonX glyphicon glyphicon-remove-sign" ></span></Button>
                      </Col>
                    </FormGroup> : null}

                    {this.state.check2 ? <FormGroup controlId="formHorizontalMiejscowosc">
                      <Col componentClass={ControlLabel} sm={4}>
                        Miejscowość:
                      </Col>
                      <Col sm={6}>
                        <FormControl className="input" placeholder="..." onChange={(e) => this.onChangeFormControl(e, 'miejscowosc')} />
                      </Col>
                      <Col sm={2}>
                        <Button onClick={()=>this.setState({check2: false})}><span className="buttonX glyphicon glyphicon-remove-sign" ></span></Button>
                      </Col>
                    </FormGroup> : null}

                    {this.state.check3 ? <FormGroup controlId="formHorizontalUlica">
                      <Col componentClass={ControlLabel} sm={4}>
                        Ulica:
                      </Col>
                      <Col sm={6}>
                        <FormControl className="input" placeholder="..." onChange={(e) => this.onChangeFormControl(e, 'ulica')} />
                      </Col>
                      <Col sm={2}>
                        <Button onClick={()=>this.setState({check3: false})}><span className="buttonX glyphicon glyphicon-remove-sign" ></span></Button>
                      </Col>
                    </FormGroup> : null}

                    {this.state.check4 ? <FormGroup controlId="formHorizontaBudynek">
                      <Col componentClass={ControlLabel} sm={4}>
                        Nr budynku:
                      </Col>
                      <Col sm={6}>
                        <FormControl className="input" placeholder="..." onChange={(e) => this.onChangeFormControl(e, 'nr_budynku')} />
                      </Col>
                      <Col sm={2}>
                        <Button onClick={()=>this.setState({check4: false})}><span className="buttonX glyphicon glyphicon-remove-sign" ></span></Button>
                      </Col>
                    </FormGroup> : null}

                    {this.state.check5 ? <FormGroup controlId="formHorizontaNrlokalu">
                      <Col componentClass={ControlLabel} sm={4}>
                        Nr lokalu:
                      </Col>
                      <Col sm={6}>
                        <FormControl className="input" placeholder="..." onChange={(e) => this.onChangeFormControl(e, 'nr_lokalu')} />
                      </Col>
                      <Col sm={2}>
                        <Button onClick={()=>this.setState({check5: false})}><span className="buttonX glyphicon glyphicon-remove-sign" ></span></Button>
                      </Col>
                    </FormGroup> : null}

                    {this.state.check6 ? <FormGroup controlId="formHorizontaTelefon">
                      <Col componentClass={ControlLabel} sm={4}>
                        Telefon:
                      </Col>
                      <Col sm={6}>
                        <FormControl className="input" maxLength="14" placeholder="..." onChange={(e) => this.onChangeFormControl(e, 'telefon')} />
                      </Col>
                      <Col sm={2}>
                        <Button onClick={()=>this.setState({check6: false})}><span className="buttonX glyphicon glyphicon-remove-sign" ></span></Button>
                      </Col>
                    </FormGroup> : null}

                    {this.state.check7 ? <FormGroup controlId="formHorizontaEmail">
                      <Col componentClass={ControlLabel} sm={4}>
                        Adres email:
                      </Col>
                      <Col sm={6}>
                        <FormControl className="email" placeholder="@" onChange={(e) => this.onChangeFormControl(e, 'email')} />
                      </Col>
                      <Col sm={2}>
                        <Button onClick={()=>this.setState({check7: false})}><span className="buttonX glyphicon glyphicon-remove-sign" ></span></Button>
                      </Col>
                    </FormGroup> : null}

                    {this.state.check8 ? <FormGroup controlId="formHorizontaStronawww">
                      <Col componentClass={ControlLabel} sm={4}>
                        Strona www:
                      </Col>
                      <Col sm={6}>
                        <FormControl className="input" placeholder="..." onChange={(e) => this.onChangeFormControl(e, 'strona_www')} />
                      </Col>
                      <Col sm={2}>
                        <Button onClick={()=>this.setState({check8: false})}><span className="buttonX glyphicon glyphicon-remove-sign" ></span></Button>
                      </Col>
                    </FormGroup> : null}

                    {this.state.check9 ? <FormGroup controlId="formHorizontaCzas">
                      <Col componentClass={ControlLabel} sm={4}>
                        Czas otwarcia:
                      </Col>
                      <Col sm={3}>
                        <FormControl className="input" placeholder="od godziny" onChange={(e) => this.onChangeFormControl(e, 'od_godziny')} />
                      </Col>
                      <Col sm={3}>
                        <FormControl className="input" placeholder="do godziny" onChange={(e) => this.onChangeFormControl(e, 'do_godziny')} />
                      </Col>
                      <Col sm={2}>
                        <Button onClick={()=>this.setState({check9: false})}><span className="buttonX glyphicon glyphicon-remove-sign" ></span></Button>
                      </Col>
                    </FormGroup> : null}

                    {this.state.check10 ? <FormGroup controlId="formHorizontaWlasnosc">
                      <Col componentClass={ControlLabel} sm={4}>
                        Własność:
                      </Col>
                      <Col sm={6}>
                        <FormControl className="input" placeholder="..." onChange={(e) => this.onChangeFormControl(e, 'wlasnosc')} />
                      </Col>
                      <Col sm={2}>
                        <Button onClick={()=>this.setState({check10: false})}><span className="buttonX glyphicon glyphicon-remove-sign" ></span></Button>
                      </Col>
                    </FormGroup> : null}

                  <FormGroup controlId="formHorizontalButtons">
                    <Col sm={4}></Col>
                    <Col sm={4}>
                      <DropdownButton dropup onSelect={(value)=>this.onSelectAddItem(value)} title="Dodaj właściwość" className={"btn btn-custom btn-lg btn-block"} id="dataDropdownButton">
                        {dataItemsMapped}
                      </DropdownButton>
                    </Col>
                    <Col sm={4}></Col>
                  </FormGroup>

                  </Form>
                </Panel>

                  <FormGroup controlId="formHorizontalButtons">
                    <Col sm={6}>
                      <input onClick={this.props.onClose} type="submit" id="btn-login" className={"btn btn-custom btn-lg btn-block"} value="Anuluj" />
                    </Col>
                    <Col sm={6}>
                      <input type="submit" id="btn-login" onClick={() => this.props.onPoiSubmit(this.prepareData())} className={"btn btn-custom btn-lg btn-block"} value="Dodaj POI" />
                    </Col>
                  </FormGroup>

              </div>
            </div>
            <div className="col-xs-2" />
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default withStyles(s)(POIModal);



// WEBPACK FOOTER //
// src/components/Modals/POIModal/POIModal.js